'use client';

import React, { useEffect } from 'react';
import TopSearchBar from '@/components/TopSearchBar';
import BottomNav from '@/components/BottomNav';
import ProfileContent from './components/ProfileContent';
import { useAuth } from '@/lib/AuthContext';
import { useRouter } from 'next/navigation';

export default function ProfilePage() {
  const { user, isLoading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    // Only redirect to profile-setup when auth is fully loaded AND user is logged in but has no username
    if (!isLoading && user && user?.profile && !user?.profile?.username) {
      router?.replace('/profile-setup');
    }
  }, [user, isLoading, router]);

  return (
    <div className="min-h-screen" style={{ background: 'var(--background)' }}>
      <TopSearchBar />
      <main className="pt-16 pb-24">
        <ProfileContent />
      </main>
      <BottomNav />
    </div>
  );
}
